<template>
  <div :class="{ best_practice: this.type == 5 }">
    <div v-if="this.type == 5" class="sidebar-cnt">
      <CategoryList :categories="categories" :type="this.type"></CategoryList>
    </div>
    <div class="content">
      <div class="header">
        <div v-if="type == 5" class="advice">
          <div class="text" v-html="$t('views.document.advice')"></div>
          <!-- <a href=""><div class="download">Descargar</div></a> -->
          <!-- <a target="_blank" :href="template_url" class="download">Descargar</a> -->
        </div>
        <!-- <div class="filter">
          <Searcher string="" :refresh="true"></Searcher>
          <LangSelector></LangSelector>
        </div> -->
      </div>

      <template v-if="this.type == 5 && files && !file">
        <waterfall
          class="waterfall-box"
          :line-gap="500"
          line="h"
          :min-line-gap="200"
          :max-line-gap="600"
          :watch="files"
          align="left"
          :fixed-height="false"
          v-if="files"
        >
          <!-- each component is wrapped by a waterfall slot -->
          <waterfall-slot
            v-for="(file, index) in files"
            :width="fileWidth(file)"
            :height="fileHeight(file)"
            :order="index"
            :key="file.id"
            class="waterfall-item"
          >
            <div class="item" @click="selectFile(file)">
              <template
                v-if="
                  file && !file.thumb && checkFileType(file.file) == 'video'
                "
              >
                <video
                  class="player"
                  autoplay
                  loop
                  muted
                  :src="file.file"
                  controls
                ></video>
              </template>
              <template v-else>
                <div
                  class="file"
                  :class="{
                    document:
                      (!file.thumb || file.thumb == '') &&
                      (file.file && checkFileType(file.file) != 'image')
                  }"
                  :style="
                    'background-image: url(' +
                      (file && file.thumb
                        ? file.thumb
                        : file.file && checkFileType(file.file) != 'image'
                        ? '/img/document.png'
                        : file.file) +
                      ');'
                  "
                >
                  <!-- <a
                target="_blank"
                :href="file.file"
                :download="file.file"
                v-if="file.thumb"
                class="download"
              >
                Descargar
              </a> -->
                </div>
              </template>
              <div class="meta">
                <div class="title">
                  {{ file.name }}
                </div>
                <div class="description" v-html="file.description"></div>
              </div>
            </div>
            <!-- <img :src="file.thumb" /> -->
          </waterfall-slot>
        </waterfall>
      </template>

      <File
        v-else-if="this.type == 5 && file"
        :file="file"
        :type="this.type"
      ></File>

      <template v-else>
        <DocumentList :type="this.type"></DocumentList>
      </template>
    </div>
  </div>
  <!-- https://rep-lsm2.s3.eu-west-1.amazonaws.com/thumb/thumb_intowinteam.jpg -->
  <!-- https://rep-lsm2.s3.eu-west-1.amazonaws.com/thumb/thumb_bahong.jpg -->
  <!-- https://rep-lsm2.s3.eu-west-1.amazonaws.com/thumb/thumb_halowin_1.jpg -->
</template>

<script>
import i18n from "@/i18n";
import CategoryList from "@/components/domain/files/CategoryList";
import Waterfall from "vue-waterfall/lib/waterfall";
import WaterfallSlot from "vue-waterfall/lib/waterfall-slot";
import DocumentList from "@/components/domain/files/DocumentList";
import File from "@/components/domain/files/File";
import Axios from "axios";

export default {
  name: "Category",
  props: { type: Number },
  components: { Axios, CategoryList, DocumentList, File, Waterfall, WaterfallSlot },
  data() {
    return {
      template_url: "http://lsm.mcdonalds.es/api/static/pdf/best_practice.pptx"
    };
  },
  computed: {
    files() {
      if (this.search) {
        var self = this;
        //this.$store.commit('setLoading', true);
        return self.$store.getters["files/searchFiles"];
      } else {
        return this.$store.getters["files/getFiles"](
          this.$store.getters["files/getCurrentCategory"]
        );
      }
    },

    categories() {
      return this.$store.getters["files/getCategories"](this.type);
    },

    file() {
      return this.$store.getters["files/getCurrentFile"];
    }
  },
  methods: {
    selectFile(item) {
      this.$store.commit("files/setCurrentFile", item);
    },
    fileWidth(file) {
      var width = 0;

      if (this.checkFileType(file.file) == "video") {
        width += 16 + 80 + 6 + 80;
      } else if (
        (!file.thumb || file.thumb == "") &&
        this.checkFileType(file.file) != "image"
      ) {
        width += 200 + 80;
      } else if (file.thumb && file.thumb != "") {
        var img = new Image();
        img.src = file.thumb;
        width += img.width && img.width != 0 ? img.width : 150;
      } else if (file.file) {
        var img = new Image();
        img.src = file.file;
        width += img.width && img.width != 0 ? img.width : 150;
      }

      return width - 80;
    },

    fileHeight(file) {
      var height = 80;
      if (this.checkFileType(file.file) == "video") {
        height += 9;
      } else if (
        (!file.thumb || file.thumb == "") &&
        this.checkFileType(file.file) != "image"
      ) {
        height += 200;
      } else if (file.thumb && file.thumb != "") {
        var img = new Image();
        img.src = file.thumb;
        height += img.height;
      } else if (file.file) {
        var img = new Image();
        img.src = file.file;
        height += img.height;
      }

      if (file.description && file.description != "") {
        // height += 100;
      }

      return height;
    },

    checkFileType(file) {
      var ext = file.substr(file.lastIndexOf(".") + 1).toLowerCase();

      var type;
      switch (ext) {
        case "png":
        case "jpg":
        case "jpeg":
        case "gif":
        case "svg":
        case "tiff":
        case "jfif":
        case "raw":
          type = "image";
          break;
        case "mp4":
        case "mov":
        case "wmv":
        case "flv":
        case "avi":
        case "webm":
          type = "video";
          break;
        default:
          type = ext;
          break;
      }
      return type;
    },

    download(url, label) {
      var self = this;
      Axios.get(url, { responseType: "blob" })
        .then(response => {
          var type;
          console.log(self.checkFileType(response.config.url));
          switch (self.checkFileType(response.config.url).toLowerCase()) {
            case "video":
              type = "video/mp4";
              break;

            case "zip":
              type = "application/zip";
              break;

            case "rar":
              type = "application/x-rar-compressed";
              break;

            default:
              type = response.data.type;
              break;
          }
          const blob = new Blob([response.data], {
            type: type
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = label;
          link.click();
          URL.revokeObjectURL(link.href);
        }).catch(err => {
           window.open(url, "_blank");
         });
    },

    loadDataPage() {
      this.$overlay.loading();
      this.$store.commit("setMenuVisible", false);

      this.$store.commit("files/setFiles", false);

      var self = this;
      this.$store
        .dispatch("files/loadCategories", { type: this.type })
        .then(function() {
          if (
            typeof self.$route.params.category !== "undefined" &&
            self.$store.getters["files/getCategoryByURL"](
              self.type,
              self.$route.params.category
            )
          ) {
            self.$store.commit("files/selectCategory", {
              type: self.type,
              category: {
                id: self.$store.getters["files/getCategoryByURL"](
                  self.type,
                  self.$route.params.category
                )
              }
            });
          } else {
            self.$store.commit("files/setCurrentFile", false);
            if (self.type == 4) {
              self.$router.replace({ name: "toolkits" });
            } else if (self.type == 5) {
              self.$router.replace({ name: "practices" });
            }
          }

          if (
            typeof self.$store.getters["files/getCurrentCategory"].id !==
            "undefined"
          ) {
            self.$store
              .dispatch("files/loadFiles", {
                id: self.$store.getters["files/getCurrentCategory"].id,
                overwride: false
              })
              .then(function() {
                if (typeof self.$route.params.resource !== "undefined") {
                  var resource = self.$store.getters["files/getResourceByURL"](
                    self.$route.params.resource
                  );
                  if (resource) {
                    self.$store.commit("files/setCurrentFile", resource);
                  } else {
                    var path = self.type == 4 ? "toolkits_category" : "practices_category";
                    self.$router.replace({
                      name: path,
                      params: {
                        category:
                          self.$store.getters["files/getCurrentCategory"].url
                      }
                    });
                  }
                }
                self.$overlay.hide();
              });
          } else {
            self.$overlay.hide();
          }
        });

      var title = "Toolkits";
      self.$store.commit("files/setCurrentFile", false);
      if (this.type == 5) {
        title = "Best Practices";
      }
      this.$store.commit("setTitle", title);
    }
  },
  watch: {
    // call again the method if the route changes
    $route: "loadDataPage"
  },
  created() {
    this.loadDataPage();
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("files/setCurrentFile", false);
    next();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.content {
  width: 100%;
  display: inline-block;
  float: right;
  padding: 20px 40px;

  .header {
    width: 100%;
    text-align: left;
    margin-bottom: 15px;
    overflow: hidden;

    /* ADVICE */
    .advice {
      overflow: auto;
      width: 85%;
      /*float: left;*/
      margin: 0 auto;
      border: 1px solid #bbb;
      background-color: #efefef;
      padding: 15px;

      .text {
        font-size: 16px;
        float: left;
        width: calc(100%);
      }

      .download {
        float: right;
        width: 150px;
        padding: 10px;
        font-size: 16px;
        background-color: var(--main_color);
        font-family: Speedee;
        cursor: pointer;
        height: 100%;
        text-decoration: none;
        text-align: center;
        color: #000;

        &:hover {
          color: #fff;
        }
      }
    }

    .filter {
      float: right;
      width: 15%;
      text-align: right;
      padding: 0 10px;

      /*.search {
          display: block;
          overflow: hidden;
          margin-top: 5px;
          -webkit-transition: all 1s;
          transition: all 1s;


          .input {
            border: none;
            border-bottom: 2px solid #ccc;
            padding: 5px;
            outline: none;
            background: url('/img/magnify.svg') no-repeat right 5px center;
            background-size: 20px;
            width: 100%;
            float: left;
          }
          .icon {
            display: none;
            cursor: pointer;
            width: 30px;
            height: 30px;
            background: url('/img/go.svg') no-repeat center var(--main_color);
            background-size: 20px;
            border-radius: 3px;
          }
          &.active {


            .input {
              width: calc( 100% - 40px );
              background: transparent;
            }
            .icon {
              display: inline-block;
            }
          }

        }*/
    }
  }
}

.best_practice {
  .sidebar-cnt {
    width: 300px;
    display: inline-block;
    float: left;
  }
  .content {
    float: right;
    width: calc(100% - 300px);

    .waterfall-box {
      .waterfall-item {
        overflow: hidden;
        height: calc(100%);
        padding: 10px;

        .item {
          height: 100%;
          width: 100%;
          padding: 10px;
          border-radius: 6px;
          border: 1px solid #ccc;
          cursor: pointer;

          video {
            width: 100%;
            height: calc(100% - 120px);
            overflow: hidden;
            border-radius: 6px;
            position: relative;
            margin-bottom: -5px;
            object-fit: cover;

            &:fullscreen {
              object-fit: contain;
            }
          }

          .file {
            width: 100%;
            height: calc(100% - 120px);
            background-size: cover;
            background-position: center center;
            overflow: hidden;
            border-radius: 6px;
            position: relative;

            &.document {
              background-size: 30%;
              background-color: #eaeaea;
            }
          }
          .download {
            position: absolute;
            background-color: var(--main_color);
            padding: 10px 15px;
            right: 0;
            top: 10%;
            border-radius: 6px 0 0 6px;
            font-family: Speedee-Bold;
            cursor: pointer;
            font-size: 16px;
            line-height: 20px;
            background-image: url("/img/download.svg");
            background-repeat: no-repeat;
            background-position: left 15px center;
            &:hover {
              color: #fff;
            }
          }

          .meta {
            text-align: left;
            padding: 0px 0 0px;
            margin-top: 5px;
            height: 120px;
            overflow: auto;
            .title {
              //   text-align: left;
              font-size: 21px;
              font-family: Speedee-Bold;
              line-height: 25px !important;
            }
            .description {
              //   text-align: left;
              font-size: 16px;
              font-family: Speedee;
              line-height: 19px;
              white-space: pre-line;
            }
          }
        }
      }
    }
  }
}
</style>
